import { useNavigate } from 'react-router-dom';

import { OmBoligenFormData } from '../types';
import { useUpdateRegistration } from '../../../../../registration/useRegistrationForm/useUpdateRegistration';
import useStore from '../../../../../../hooks/useStore';
import { formDataToUserInput } from '../utils/dataMapper';
import { RegistrationCommonStep } from '../../../../../../utils/navigation';
import { useRegistrationSteps } from '../../../../hooks/useRegistrationSteps';

export const useOmBoligenSubmit = (registrationId: string) => {
  const { updateRegistration, updateIsLoading, updateError } = useUpdateRegistration(registrationId);
  const store = useStore();
  const userInput = store.getState().register.userInput;
  const navigate = useNavigate();
  const { nextStep } = useRegistrationSteps(RegistrationCommonStep.ABOUT);

  const onOmBoligenSubmit = (data: OmBoligenFormData) => {
    // Transform form data to Bygningsdetaljer
    const updatedUserInput = formDataToUserInput(data, userInput);

    updateRegistration(
      { registrationId: data.registreringId, userInput: updatedUserInput },
      {
        onSuccess: () => navigate(`../${nextStep}`)
      }
    );
  };
  return { onOmBoligenSubmit, isLoading: updateIsLoading, updateError };
};
